// import Swiper JS
import Swiper, { Navigation, Pagination } from "swiper";
import Alpine from "alpinejs";
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const carSlides = new WeakMap();
const observedCarSliders = new WeakSet();
const carSliderObserver = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (!entry.isIntersecting) return;
		carSliderObserver.unobserve(entry.target);
		initListCarsSwiper(entry.target);
	});
}, { rootMargin: "300px" }) : null;

function getCarSlides(element) {
	if (!carSlides.has(element)) {
		carSlides.set(element, Array.from(element.querySelector(".swiper-wrapper").children));
	}
	return carSlides.get(element);
}

document.addEventListener("alpine:init", () => {
	Alpine.data("carSlider", () => ({
		selectedMake: "all",
		init() {
			getCarSlides(this.$root.querySelector(".listCarsSwiper"));
		},
		selectMake(make) {
			if (this.selectedMake === make) return;
			this.selectedMake = make;
			const element = this.$root.querySelector(".listCarsSwiper");
			const slides = getCarSlides(element);
			if (element.swiper) element.swiper.destroy(true, true);
			delete element.dataset.swiperInitialized;
			element.querySelector(".swiper-wrapper").replaceChildren(...slides.filter((slide) => make === "all" || slide.dataset.carMake === make));
			initListCarsSwiper(element);
		},
	}));
});

function getSlideCount(element) {
	return element.querySelectorAll(".swiper-slide").length;
}

function initSwiperOnce(element, options) {
	if (!element || element.swiper || element.dataset.swiperInitialized === "true") {
		return null;
	}

	element.dataset.swiperInitialized = "true";
	return new Swiper(element, options);
}

function initListCarsSwiper(element) {
	const slideCount = getSlideCount(element);
	const paginationEl = element.querySelector(".swiper-pagination");
	const modules = paginationEl ? [Pagination] : [];

	return initSwiperOnce(element, {
		modules,
		slidesPerView: 1.15,
		spaceBetween: 24,
		autoHeight: false,
		watchOverflow: true,
		resizeObserver: false,
		loop: slideCount > 1,
		pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
		breakpoints: {
			0: {},
			640: { slidesPerView: 3.5 },
		},
	});
}

function initSwipers() {
	document.querySelectorAll(".gallery-car").forEach((element) => {
		const slideCount = getSlideCount(element);
		const nextButton = element.querySelector(".ph-caret-right");
		const prevButton = element.querySelector(".ph-caret-left");

		initSwiperOnce(element, {
			modules: [Navigation],
			slidesPerView: 1.4,
			loop: slideCount > 1,
			centeredSlides: slideCount > 1,
			spaceBetween: 6,
			autoHeight: false,
			watchOverflow: true,
			resizeObserver: false,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			breakpoints: {
				0: {},
				640: {
					slidesPerView: 3.5,
				},
			},
		});
	});

	document.querySelectorAll(".listCarsSwiper").forEach((element) => {
		if (element.swiper || observedCarSliders.has(element)) return;
		getCarSlides(element);
		if (carSliderObserver) {
			observedCarSliders.add(element);
			carSliderObserver.observe(element);
		} else {
			initListCarsSwiper(element);
		}
	});

	document.querySelectorAll(".sliderGridItem").forEach((element) => {
		const slideCount = getSlideCount(element);
		const nextButton = element.querySelector(".sliderGridItem-next");
		const prevButton = element.querySelector(".sliderGridItem-prev");

		initSwiperOnce(element, {
			modules: [Navigation],
			loop: slideCount > 1,
			watchOverflow: true,
			resizeObserver: false,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initSwipers);
} else {
	initSwipers();
}

window.initSwipers = initSwipers;
